import React from 'react';

import * as S from './styles';
import { formatCurrency, formatDate, formatPercent } from '../../../../../util/common/appUtil';
import { INegotiationSimulation } from '../../../../../interfaces/newStudent/negotiation.interface';

interface Props {
  simulation: INegotiationSimulation;
  paymentLabel: string;
}

export default function NegotiationSummary({ simulation, paymentLabel }: Props) {
  const showIncrease =
    simulation.isCreditCard || simulation.financialIncreaseAmount > 0;

  return (
    <S.Container>
      {simulation.informationText ? (
        <S.InfoBox>
          <S.InfoIcon />
          <S.InfoCopy>
            <S.InfoTitle>Pagamento por Cartão de Crédito</S.InfoTitle>
            <S.InfoText>{simulation.informationText}</S.InfoText>
          </S.InfoCopy>
        </S.InfoBox>
      ) : null}
      <S.Card>
        <S.CardTitle>Resumo da negociação</S.CardTitle>
        <S.Columns>
          <S.Breakdown>
            <S.Line>
              <S.Sign />
              <S.Label>Valor atualizado do débito</S.Label>
              <S.Value>{formatCurrency(simulation.debtAmount)}</S.Value>
            </S.Line>
            <S.Line>
              <S.Sign>+</S.Sign>
              <S.Label>Encargos do débito em atraso</S.Label>
              <S.Value>{formatCurrency(simulation.chargesAmount)}</S.Value>
            </S.Line>
            <S.SubLine>
              <span />
              <span>Juros</span>
              <span>{formatCurrency(simulation.interestAmount)}</span>
            </S.SubLine>
            <S.SubLine>
              <span />
              <span>Multa</span>
              <span>{formatCurrency(simulation.fineAmount)}</span>
            </S.SubLine>
            {simulation.discountAmount > 0 ? (
              <S.Line>
                <S.Sign>−</S.Sign>
                <S.Label>Desconto</S.Label>
                <S.Value>{formatCurrency(simulation.discountAmount)}</S.Value>
              </S.Line>
            ) : null}
            {showIncrease ? (
              <S.Line>
                <S.Sign>+</S.Sign>
                <S.Label>
                  Acréscimo financeiro do parcelamento (
                  {formatPercent(simulation.operatorFeePercent)})
                </S.Label>
                <S.Value>{formatCurrency(simulation.financialIncreaseAmount)}</S.Value>
              </S.Line>
            ) : null}
          </S.Breakdown>
          <S.TotalPanel>
            <S.TotalLabel>VALOR TOTAL DA NEGOCIAÇÃO</S.TotalLabel>
            <S.TotalValue>{formatCurrency(simulation.totalAmount)}</S.TotalValue>
            <S.PaymentBand>
              <span>Forma de pagamento: {paymentLabel}</span>
              <span>
                Parcelamento: {simulation.installments}x de{' '}
                {formatCurrency(simulation.installmentAmount)}
              </span>
              <span>1º vencimento: {formatDate(simulation.firstDueDate)}</span>
            </S.PaymentBand>
          </S.TotalPanel>
        </S.Columns>
      </S.Card>
      <S.NoticeBox>
        <S.NoticeIcon />
        <S.InfoCopy>
          <S.InfoTitle>Atenção ao prazo de pagamento</S.InfoTitle>
          <S.InfoText>{simulation.autoCancelText}</S.InfoText>
        </S.InfoCopy>
      </S.NoticeBox>
    </S.Container>
  );
}
